<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-list">
      Sessions
    </PageTitle>
    <v-card>
      <allergan-device-sessions-table v-if="canMangeAllerganDeviceSessions"
                                      :sessions="sessions"
                                      :loading="form.busy"
                                      @updated="fetchData">
      </allergan-device-sessions-table>
      <device-sessions-table v-else
                             :sessions="sessions"
                             :loading="form.busy"
                             @updated="fetchData">
      </device-sessions-table>
    </v-card>
  </v-container>
</template>
<script>
import {mapGetters} from "vuex";
import {Form} from 'vform';
import AllerganDeviceSessionsTable from "./components/AllerganDeviceSessionsTable";
import DeviceSessionsTable from "./components/DeviceSessionsTable";
import PageTitle from '../../components/PageTitle.vue';
import {orderBy} from 'lodash';

export default {
  components: {PageTitle, DeviceSessionsTable, AllerganDeviceSessionsTable},
  data() {
    return {
      form: new Form({
        order_by: 'started_at',
        order_dir: 'desc',
        session_type: 'normal',
        team_id: null,
        user_id: null,
      }),
      sessions: [],
      meta: null,
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'isAdmin',
      'team',
      'user',
    ]),
    canMangeAllerganDeviceSessions() { // MLD-3014
      return this.team
        && this.team.id === 199
        && this.user
        && this.user.is_full_user;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.form.team_id = this.user.current_team_id;
      this.form.user_id = this.user.id;
      if (this.canMangeAllerganDeviceSessions) {
        this.form.get(`/api/clients/agnma/user/device-sessions`)
          .then(({data}) => {
            this.sessions = orderBy(data, ['started_at'], ['desc']);
          })
          .catch(err => {

          })
      } else {
        const options = {
          params: {
            include_entities: 1,
          }
        }
        this.form.get(`/api/device-sessions`, options)
          .then(({data}) => {
            this.sessions = data.data;
          })
          .catch(err => {

          })
      }
    }
  }
}
</script>
